// libraries.
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

// components.
import GoogleMap from '@domains/google-map/GoogleMap';
import { LocationMarker } from './LocationMarker';
import { MedianZonesPolygons } from './MedianZonesPolygons';

// selectors.
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';

// Map centers by country
const MAP_CENTERS: Record<string, google.maps.LatLngLiteral> = {
  CO: {
    lat: 4.60971,
    lng: -74.08175,
  }, // Bogotá, Colombia
  MX: {
    lat: 19.432608,
    lng: -99.133209,
  }, // Ciudad de México, México
};

// Default center (Bogotá)
const DEFAULT_CENTER: google.maps.LatLngLiteral = MAP_CENTERS.CO;

export const GeoreferencingMap = () => {
  const country = useSelector(getCountry);

  const mapCenter = useMemo(() => {
    return (country && MAP_CENTERS[country]) || DEFAULT_CENTER;
  }, [country]);

  return (
    <GoogleMap
      containerStyle={{
        height: '100%',
        width: '100%',
      }}
      defaultCenter={mapCenter}
      defaultZoom={12}
      libraries={['places']}
    >
      <LocationMarker />
      <MedianZonesPolygons />
    </GoogleMap>
  );
};
